// eslint-disable-next-line import/prefer-default-export
export function logout(record) {
  const { location } = window;
  const redirect = record
    ? encodeURIComponent(location.hash.length > 0 ? location.hash.slice(1) : '')
    : '';
  const redirectUrl = `/web/simple/${location.search}#/login?redirect=${redirect}`;
  location.href = `/api/cs-pc-crm/oauth2/logout?redirect_uri=${encodeURIComponent(redirectUrl)}`;
}

/**
 * code:
 * http状态码用数字
 * 弹窗用popup-弹窗名
 */
const dialogMap = new Map();
export function dialogSingle(code, proFn) {
  if (!dialogMap.get(code)) {
    dialogMap.set(
      code,
      Promise.resolve(proFn()).finally(() => {
        dialogMap.delete(code);
      }),
    );
  }
}
